<ol class="timeline" data-testid="dictionary-versions">
  @for (version of versions(); track version.number) {
    @let isActive = version.status === 'Active';
    @let changed = version.changedEntries ?? [];
    <li
      class="timeline__item"
      [class.timeline__item--active]="isActive"
      data-testid="dictionary-version-item">
      <span class="timeline__dot" aria-hidden="true"></span>
      <div class="timeline__card">
        <header class="timeline__header">
          <div class="timeline__titles">
            <h5 class="timeline__number">Versão {{ version.number }}</h5>
            <span class="tag" [attr.data-source]="version.source">
              {{ sourceLabel(version.source) }}
            </span>
            @if (isActive) {
              <span class="tag tag--active" data-testid="dictionary-version-active">Em uso</span>
            }
          </div>
          <span class="timeline__meta">
            @if (version.createdByName) {
              {{ version.createdByName }}
            }
            @if (version.activatedAt) {
              · {{ version.activatedAt | vaultDateTime }}
            }
          </span>
        </header>

        @if (version.summary) {
          <p class="timeline__summary">{{ version.summary }}</p>
        }
        @if (version.reason) {
          <p class="timeline__reason">
            <span>Motivo:</span>
            {{ version.reason }}
          </p>
        }
        @if (version.basedOnVersionNumber && version.source === 'Rollback') {
          <p class="timeline__based">Cópia da versão {{ version.basedOnVersionNumber }}.</p>
        }

        @if (changed.length > 0) {
          <div class="timeline__changed">
            <span class="timeline__changed-title">
              {{ changed.length }}
              {{ changed.length === 1 ? 'verbete alterado' : 'verbetes alterados' }}
            </span>
            <div class="timeline__chips">
              @for (entry of changed.slice(0, maxChangedEntries); track $index) {
                <span class="timeline__chip">
                  {{ entry.label }}
                  <small>{{ statementTypeLabel(entry.statementType) }}</small>
                </span>
              }
              @if (changed.length > maxChangedEntries) {
                <span class="timeline__chip timeline__chip--more">
                  e mais {{ changed.length - maxChangedEntries }}
                </span>
              }
            </div>
          </div>
        }

        @if (!isActive && canManage()) {
          <div class="timeline__actions">
            <app-button
              [label]="'Voltar para esta versão'"
              [icon]="'pi pi-history'"
              [theme]="'white'"
              [type]="'button'"
              [disabled]="locked()"
              data-testid="dictionary-version-rollback"
              (sendButtonClick)="rollbackRequested.emit(version)" />
          </div>
        }
      </div>
    </li>
  }
</ol>
